import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import React from 'react';

const DisclaimerText = () => {
  const { t } = useTranslation();
  const disclaimerKeys = [
    'beforeProceeding',
    'description',
    'tosDocAccess',
    'resourceOffering',
    'documentAccessibility',
    'docAccuracy',
    'disclaimers',
    'legalities',
    'redistribution',
    'intellectualProperty',
    'contactInfo',
  ];
  return (
    <>
      <p>
        <b>{t('disclaimerText.beforeProceeding')}</b>
      </p>
      <p>
        {t('disclaimerText.description')}
        <Link
          id='disclaimerTextTermsAndConditionsLink'
          to='https://www.businesskitz.com/terms-and-conditions'
          target='_blank'
          rel='noreferrer noopener'
        >
          {t('links.termsAndConditions')}
        </Link>
        {' and Business Kitz '}
        <Link
          id='disclaimerTextPrivacyPolicyLink'
          to='https://www.businesskitz.com/privacy-policy'
          target='_blank'
          rel='noreferrer noopener'
        >
          {t('links.privacyPolicy')}
        </Link>
      </p>
      {disclaimerKeys.slice(2).map((key) => (
        <p key={key}>{t(`disclaimerText.${key}`)}</p>
      ))}
    </>
  );
};

export default DisclaimerText;
